import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './Gallery.css';
import treatmentArea from '../../assets/newGalleryPics/clinicChairAreaResized.jpg';
import watingArea from '../../assets/newGalleryPics/receptionSittingAreaResized.jpg';
import clinicImage from "../../assets/newGalleryPics/receptionAreaResized.jpg";
import DentalLab from '../../assets/newGalleryPics/laborataryAreaResized.jpg';
import Operatory1 from '../../assets/newGalleryPics/operatory1Resized.jpg';
import Operatory2 from '../../assets/newGalleryPics/operatory2Resized.jpg';
import newImage from '../../assets/newGalleryPics/consultingAreaResized.jpg';
import FrontClinicDayView from '../../assets/newGalleryPics/clinicFrontViewNew.jpg';
import SideClinicNightView2 from '../../assets/newGalleryPics/ClinicNightViewNew.jpg';
import clinicNightSideView from '../../assets/newGalleryPics/clinicNightviewFont.jpg';
import beforeAfter1 from '../../assets/beforeAfterPics/beforeAfternew1.png';
import beforeAfter2 from '../../assets/beforeAfterPics/beforeAfterSecond.png';
import beforeAfter3 from '../../assets/beforeAfterPics/beforeAfterThird.png';
import beforeAfter4 from '../../assets/beforeAfterPics/beforeAfterforth.png';
import beforeAfter5 from '../../assets/beforeAfterPics/beforeAfterFifth.png';
import beforeAfter6 from '../../assets/beforeAfterPics/beforeAfterSixth.png';
import { FloatingWhatsApp } from "react-floating-whatsapp";
import {whatsAppBotListener } from "../../utils/Utils";
import { PHONE_NUMBER } from "../../utils/Constant";
import clinicIcon from '../../assets/ivory/DenviaLogo.png';



const Gallery = () => {
  const { type } = useParams();
  const location = useLocation();

  // Determine which gallery to show based on route
  const isClinicGallery = location.pathname === '/gallery/clinic';
  const isOurWork = location.pathname === '/gallery/our-work';

  // Sample data - Replace with your actual images
  const clinicImages = [
    { id: 1, url: clinicImage },
    { id: 2, url: treatmentArea },
    { id: 3, url: watingArea },
    { id: 4, url: newImage },
    { id: 5, url: DentalLab },
    { id: 6, url: Operatory1 },
    { id: 7, url: Operatory2 },
    { id: 9, url: FrontClinicDayView },
    { id: 10, url: SideClinicNightView2 },
    {id: 11, url:clinicNightSideView}
  ];


  const ourWorkImages = [
    { id: 1, url: beforeAfter1 },
    { id: 2, url: beforeAfter2 },
    { id: 3, url: beforeAfter3 },
    { id: 4, url: beforeAfter4 },
    { id: 5, url: beforeAfter5 },
    { id: 6, url: beforeAfter6 },
  ];


  const currentImages = isClinicGallery ? clinicImages : ourWorkImages;
  const pageTitle = isClinicGallery ? 'Our Clinic' : 'Our Work';
  const pageSubtitle = isClinicGallery      
    ? 'Take a tour of our state-of-the-art dental facility' 
    : 'See the amazing transformations we\'ve achieved for our patients';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <section className="gallery-section">
      <div className="container">
        {/* Header */}
        <div className="gallery-header">
          <h1 className="gallery-title">{pageTitle}</h1>
          <p className="gallery-subtitle">{pageSubtitle}</p>
        </div>

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {currentImages.map((image, index) => (
            <div 
              key={image.id} 
              className="gallery-item"
              data-aos="fade-up"
              data-aos-delay={`${index * 100}`}
            >
              <div className="gallery-image-wrapper">
                <img src={image.url} alt="imageGallaryPics" />
                <div className="gallery-overlay"></div>
              </div>
            </div>

          ))}
        </div>
      </div>
                  {/* What's app bot section */}
                  <FloatingWhatsApp
                      avatar={clinicIcon}
                      notification={false}
                      accountName="Denvia Dental Clinic"
                      phoneNumber={PHONE_NUMBER}
                      onSubmit={(e) => {
                          whatsAppBotListener(e.target[0].value);
                      }}
                  />
    </section>
  );
};

export default Gallery;
